import React, { useEffect, useState } from 'react'
import { FaUserPlus } from 'react-icons/fa';
import { HiOutlineClipboardCheck } from 'react-icons/hi';
import { FiRefreshCcw } from 'react-icons/fi';
import { ImSpinner2 } from 'react-icons/im';
import * as report from '../../../configurations/crud/reportCrud';
import { useParams } from 'react-router-dom';
import { EOPDRegisteredStatusBg, EOPDRegisteredStatusText, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus';
import { EOPDConfirmedStatusText, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { MdErrorOutline, MdOutlineInsights, MdOutlineCalendarMonth } from 'react-icons/md';
import { useToast } from '../../controls/Toast/ToastService'
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import moment from 'moment';


export default function ForDateShortReport({ centerId, forDate }) {
    const { start, end } = useGlobalLoader()
    const [registered, setRegistered] = useState([]);
    const [confirmed, setConfirmed] = useState([]);
    const [total, setTotal] = useState({ registered: 0, confirmed: 0 });
    const [loading, setLoading] = useState(true);
    const { centerid } = useParams()
    const toast = useToast()

    useEffect(() => {
        if (centerId && forDate)
            getDailyCenter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [centerId, forDate]);

    const getDailyCenter = () => {
        setLoading(true);
        start()
        report.DailySummary({ centerId: centerId, ForDate: forDate, Normal: 150, NewEntry: 200 })
            .then(res => { console.log(res) })
        report.ForDateCenter({ centerId: centerId, ForDate: forDate })
            .then(res => {
                const mdata = res.data;
                if (mdata.result.succeeded) {
                    setRegistered(mdata.registered)
                    setConfirmed(mdata.confirmed)
                    let regSum = mdata.registered.reduce((sum, cur) => sum + cur.count, 0)
                    let conSum = mdata.confirmed.reduce((sum, cur) => sum + cur.count, 0)

                    setTotal({ registered: regSum, confirmed: conSum })
                } else {
                    // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                }
                setLoading(false);
                end()
            })
            .catch(errors => {
                // toast.open(errors, <MdErrorOutline />, "danger")
                setLoading(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    };

    return (
        <div className="mb-4">
            <div className="rounded-2xl border border-gray-200 bg-white p-3 shadow-sm transition hover:shadow-md">

                {/* header */}
                <div className="mb-2 flex flex-wrap items-center justify-between gap-1">
                    <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                        <MdOutlineInsights className="text-sm text-brand-500" />
                        Summary for Selected Date
                        {forDate &&
                            <span className="inline-flex items-center gap-1 normal-case tracking-normal text-gray-500">
                                <MdOutlineCalendarMonth className="text-sm" />
                                {moment(forDate, "MM/DD/YYYY").format("DD MMM YYYY")}
                            </span>
                        }
                    </span>
                    <button
                        title="Refresh"
                        onClick={getDailyCenter}
                        className="grid h-8 w-8 place-items-center rounded-lg text-green-700 transition hover:bg-gray-100 active:scale-95"
                    >
                        <FiRefreshCcw className={loading ? "animate-spin" : ""} />
                        <span className="sr-only">Refresh</span>
                    </button>
                </div>

                {/* groups */}
                <div className="flex flex-col gap-3 lg:flex-row lg:gap-4">
                    <ReportGroup
                        title="Confirmed"
                        Icon={HiOutlineClipboardCheck}
                        iconColor="text-green-500"
                        items={confirmed}
                        total={total.confirmed}
                        loading={loading}
                        nameFn={GetEOPDConfirmedStatusName}
                        colorFn={EOPDConfirmedStatusText}
                    />
                    <div className="hidden w-px shrink-0 bg-gray-100 lg:block" />
                    <ReportGroup
                        title="Registered"
                        Icon={FaUserPlus}
                        iconColor="text-blue-500"
                        items={registered}
                        total={total.registered}
                        loading={loading}
                        nameFn={GetEOPDRegisterStatusName}
                        colorFn={EOPDRegisteredStatusText}
                    />
                </div>
            </div>
        </div>
    )
}

/* ---------- helper ---------- */
function ReportGroup({ title, Icon, iconColor, items, total, loading, nameFn, colorFn }) {
    return (
        <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-1.5 text-xs sm:text-sm">
                <span className="inline-flex items-center gap-1.5 font-semibold text-gray-700">
                    {Icon && <Icon className={`text-sm ${iconColor || "text-blue-500"}`} />} {title}
                </span>

                {loading ? (
                    <ImSpinner2 className="animate-spin text-lg text-green-600" />
                ) : (
                    <>
                        {items.length > 0 ? (
                            items.map((item, index) => (
                                <span key={item.status ?? index} className="inline-flex items-center gap-1 rounded-lg bg-gray-50 px-2 py-1 text-xs ring-1 ring-gray-100">
                                    <span className={colorFn(item.status)}>{nameFn(item.status)}:</span>
                                    <span className="font-bold text-gray-900">{item.count}</span>
                                </span>
                            ))
                        ) : (
                            <span className="text-xs text-gray-400">No data</span>
                        )}
                        <span className="inline-flex items-center gap-1 rounded-lg bg-brand-50 px-2 py-1 text-xs font-semibold text-brand-700">
                            Total <span className="font-bold">{total}</span>
                        </span>
                    </>
                )}
            </div>
        </div>
    )
}